import type { AdminCategorySelectListDto } from '@@types/api.types';
import { Badge } from '@components/ui/badge';
import type { ColumnDef } from '@tanstack/react-table';

export const createCategoriesColumns = (): ColumnDef<AdminCategorySelectListDto>[] => [
  {
    id: 'category',
    accessorFn: (row) => {
      const parent = row.parentCategory?.name;
      return parent ? `${parent} > ${row.name}` : row.name;
    },
    header: 'Category',
    size: 500,
    cell: ({ row }) => {
      const parent = row.original.parentCategory;
      if (parent) {
        return (
          <div className="font-medium text-gray-900">
            <span className="text-gray-500">{parent.name}</span>
            <span className="text-gray-400 mx-1">&gt;</span>
            <span>{row.original.name}</span>
          </div>
        );
      }
      return <div className="font-medium text-gray-900">{row.original.name}</div>;
    },
  },
  {
    id: 'status',
    accessorFn: (row) => row.archived,
    header: 'Status',
    size: 150,
    sortingFn: 'text',
    cell: ({ row }) => {
      const archived = row.original.archived;
      const variant = archived ? 'warning' : 'success';
      const label = archived ? 'Archived' : 'Available';
      return (
        <Badge
          size="xs"
          variant={variant}
        >
          {label}
        </Badge>
      );
    },
  },
];
